import type { RequestConfig } from '@customTypes/index';
import type { ArtistProfileStatus } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ArtistGetProfileStatusRequest = {
  profileId: string;
};

type ArtistGetProfileStatusResponse = {
  status: ArtistProfileStatus;
};

export type ArtistGetProfileStatusParams =
  RequestConfig<ArtistGetProfileStatusRequest>;

export const artistGetProfileStatus = async ({
  params,
  config
}: ArtistGetProfileStatusParams) =>
  api.get<ArtistGetProfileStatusResponse>(
    `/api/ArtistProfile/${params.profileId}/profile-status`,
    config
  );
